import { Component, OnInit, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-anchor-form',
  templateUrl: './anchor-form.component.html',
  styleUrls: ['./anchor-form.component.css']
})
export class AnchorFormComponent implements OnInit {

  @Input("form") form: FormGroup;

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/components/utils/item-type-manager/forms/anchor-form/anchor-form.component.ts